// Dependent on this.route.query.query for keyword setup. (mainly used for search)
export const markedWords = {
  methods: {
    markedWords (text) {
      let str = this.$route.query.query;
      if (str && str.length) {
        str = str.replace(/"/g, "");
        // Support searching e.g. "Q&A", & -> &amp;
        str = str.replace(/&/g, "&amp;");

        // Force encoding of nbsp and ampersand + more (similar to previous implementation)
        const tmpElement = document.createElement("div");
        tmpElement.innerHTML = text;
        text = tmpElement.innerHTML;

        // There are more generic and steadfast ways to do this, but this solves the majority of cases.
        const ignoreSegmentsWithinThese = [...text.matchAll(/&amp;|&nbsp;|&lt;|&gt;/g).map(match => {
          return {start: match.index, end: match.index+match[0].length};
        })];

        // Case insensitive keyword matching, mapping out all segments of the original string needing highlight
        const keywords = str.toLowerCase().split(" ");
        const lowercaseText = text.toLowerCase();

        let segmentsToMark = keywords.flatMap((keyword) => {
          const segments = [];
          let index = lowercaseText.indexOf(keyword);
          while (index !== -1) {
            segments.push({
              start: index,
              end: index + keyword.length,
            });
            index = lowercaseText.indexOf(keyword, index+1);
          }
          return segments;
        });

        segmentsToMark = segmentsToMark.filter(segment => {
          for(const ignored of ignoreSegmentsWithinThese) {
            //Exclude &, include html entity semicolon. This is technically not going to be very well functioning if
            if(segment.start > ignored.start && segment.end <= ignored.end && segment.start <= ignored.end && segment.end > ignored.start) {
              return false;
            }
          }
          return true;
        })

        // Sorted segments by start allows only checking if we overlap/merge latest added segment below
        segmentsToMark.sort((a, b) => {
          return a.start - b.start;
        });

        // Merge overlapping/adjacent segments until we have segments that can be highlighted without interfering with each other
        if (segmentsToMark.length > 0) {
          const merged = [segmentsToMark.shift()];

          while (segmentsToMark.length > 0) {
            const segment = segmentsToMark.shift();
            if (segment.start > merged[merged.length - 1].end) {
              merged.push(segment);
            } else {
              if (segment.end > merged[merged.length - 1].end) {
                merged[merged.length - 1].end = segment.end;
              }
            }
          }

          // Mark the final segments in the original string.
          let offset = 0;
          merged.forEach((segment) => {
            text = text.slice(0, segment.start+offset) + "<mark>" + text.slice(segment.start+offset, segment.end+offset) + "</mark>" + text.slice(segment.end+offset);
            // Account for added <mark></mark> for next segment.
            offset+= 13;
          });
        }
      }

      return text;
    },
  },
};
